(function() {
    'use strict';
    
a3_cabin_reports.factory('MemoImagesFactory', MemoImagesFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name MemoImagesFactory
    * @description 
    *   Add, Update, Delete and Get Memo's Images.
    * @ngInject
    */  
function MemoImagesFactory(GenericService, IndexedDBService) {

         /**
        * Initialize the MemoImage
        * @memberof MemoImagesFactory
        */
		function MemoImage() {
			this.Id = null;
		}

		var objType = 'MemoImages';
		var objCallback = MemoImage;

		var service = 
		{  
			getMemoImagesFromStorage : getMemoImagesFromStorage,
			setMemoImagesToStorage : setMemoImagesToStorage,
			saveOneMemoImageToStorage : saveOneMemoImageToStorage,
			addMemoImageToStorage : addMemoImageToStorage,
			deleteMemoImageFromStorage : deleteMemoImageFromStorage,
			deleteMemoImageByMemoId : deleteMemoImageByMemoId,
			setImagesToServer : setImagesToServer,
			clearMemoImagesFromStorage : clearMemoImagesFromStorage,
            getMemoImagesByIndex : getMemoImagesByIndex,
            info : info
		};
				
        /**
         * Get Memo Images 
         * @memberof MemoImagesFactory
         * @param {function} callback  
         */
		function getMemoImagesFromStorage(callback) {
			//return GenericService.list(objType,objCallback);
			IndexedDBService.getAll(objType).then(function(results){
				callback(results);
			});
		};

        /**
         * Get Memo Images  by memo Id
         * @memberof MemoImagesFactory
         * @param {number} id Memo Id  
         * @param {function} callback  
         */
        function getMemoImagesByIndex(id,callback) {
			//return GenericService.list(objType,objCallback);
			IndexedDBService.getByIndex(objType,'memoId',id).then(function(results){
				callback(results);
			});
		};

        /**
         * Add Memo Images 
         * @memberof MemoImagesFactory
         * @param {array} MemoImages List of memo images
         */
		function setMemoImagesToStorage(MemoImages) {
			//GenericService.saveAll(Memos,objType,objCallback);
			IndexedDBService.addAll(objType, MemoImages);
		};

        function info(){
            IndexedDBService.info(objType);
        }


        /**
         * Update Memo Images 
         * @memberof MemoImagesFactory
         * @param {object} MemoImage a memo image
         */
		function saveOneMemoImageToStorage(MemoImage){
			IndexedDBService.put(objType, MemoImage);
		};

        /**
         * Add Memo Image
         * @memberof MemoImagesFactory
         * @param {object} MemoImage a memo image
         */
		function addMemoImageToStorage(MemoImage){
			IndexedDBService.add(objType, MemoImage);
		};

        /**
         * Delete  Memo Image
         * @memberof MemoImagesFactory
         * @param {number} MemoImageId a memo image Id
         */
		function deleteMemoImageFromStorage(MemoImageId){
			IndexedDBService.remove(objType, MemoImageId);
		};
    
        /**
         * Delete  Memo Image by MemoId
         * @memberof MemoImagesFactory
         * @param {number} MemoId a memo Id
         */
        function deleteMemoImageByMemoId(MemoId){
			IndexedDBService.removeByIndex(objType,'memoId', MemoId);
		};
    
        /**
         * Set  Memo Image by api call
         * @memberof MemoImagesFactory
         * @param {array} images List of memo images
         */     
        function setImagesToServer(images){
            for(var i=0;i<images.length;i++){
                addMemoImageToStorage(images[i]);
            } 
        }

        /**
         * Remove  Memo Images from storage
         * @memberof MemoImagesFactory
         */    
		function clearMemoImagesFromStorage() {
			IndexedDBService.removeAll(objType);
		};


		return service;
	}


})();